//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    // 父辈向子辈传参
  },
  name: "HeadAd",
  data() {
    return {
      firstSwiperOption: {
        autoplay: {
          delay: 10000,
        },
        speed: 1000,
        loop: false,
        autoplayDisableOnInteraction: false,
        on: {},
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        spaceBetween: 10,
      },
    };
  },
  async asyncData() {},
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
    ...mapGetters("cart", ["cartTotal"]),
    ...mapGetters("user", ["isLogin", "getTopAdShow"]),
    ...mapGetters(["getTopInfo"]),
  },
  components: {
    // 组件的引用
  },
  methods: {
    ...mapMutations("user", ["setTopAdShow"]),
    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-19 14:20:35
     * @LastAuthor: liudanli 565478958@qq.com
     * @description: 获取顶部广告的信息
     * @return {*}
     * @Description: Do not Description
     */
    async getHomeTopHandler() {
      try {
        let topInfoRes = await this.$homeTop();
        this.topInfo = topInfoRes.data.configs;
        this.topBanner = this.topInfo.topBanner;
        // if (this.topInfo.topEndTime) {
        //这儿应该加个配置 倒计时是否开启
        //   this.countdown();
        // }
      } catch (error) {
        throw new Error("获取顶部信息" + error);
      }
    },

    closeAd() {
      try {
        this.setTopAdShow(false);
      } catch (error) {
        throw new Error("关闭顶部广告" + error);
      }
    },
    async countdown() {
      try {
        if (this.topInfo.topEndTime) {
          let getSeverTime = await this.$serverTime();
          let severDate = this.$dayjs(getSeverTime.data.now).valueOf();
          let endTime = this.$dayjs(this.topInfo.topEndTime).valueOf();

          this.tool.countDown(endTime - severDate, 100, (obj) => {
            this.countdownStr = `${obj.h} H ${obj.m} M ${obj.s} S ${obj.ms / 10 ? obj.ms / 10 : "00"} `;
          });
        }
      } catch (error) {
        throw new Error("顶部倒计时" + error);
      }
    },
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
